// extracted by mini-css-extract-plugin
export default {"Stenth":"Stenth_Stenth__HiBEM","wrap":"Stenth_wrap__Ig9XA","text":"Stenth_text__pcBJ8","title":"Stenth_title__vVxy-","desc":"Stenth_desc__zo4LP"};